import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

const TooltipInfo = ({ titleText, onClose, severity, message }) => {
  return (
    <Tooltip title={titleText} enterTouchDelay={0}>
      <IconButton size="large">
        <QuestionMarkIcon />
      </IconButton>
    </Tooltip>
  );
};

export default TooltipInfo;